import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListCheck20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconListCheck20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.014 4.75a.75.75 0 0 1-.75.75H9.585a.75.75 0 0 1 0-1.5h8.679a.75.75 0 0 1 .75.75m-2.003 3.5a.75.75 0 0 1-.75.75H9.585a.75.75 0 0 1 0-1.5h6.676a.75.75 0 0 1 .75.75m1.253 4.25a.75.75 0 0 0 0-1.5H9.585a.75.75 0 0 0 0 1.5zm-1.253 2.75a.75.75 0 0 1-.75.75H9.585a.75.75 0 0 1 0-1.5h6.676a.75.75 0 0 1 .75.75M6.6 4.87a.75.75 0 0 1 0 1.06l-2.8 2.8-.531.53-.53-.53-1.4-1.4A.75.75 0 0 1 2.4 6.27l.87.87 2.27-2.27a.75.75 0 0 1 1.06 0M4.5 12.5h-2v2h2zm-2-1.5A1.5 1.5 0 0 0 1 12.5v2A1.5 1.5 0 0 0 2.5 16h2A1.5 1.5 0 0 0 6 14.5v-2A1.5 1.5 0 0 0 4.5 11z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListCheck20);
